export const handleLogout = async ({ logoutUser, navigate }) => {
  const logout = await logoutUser();
  console.log({ logout });
  if (logout?.data?.success === true) {
    navigate("/");
    console.log("logout success");
  }
};
